export const HeliumType = {
  VISUALIZATION: 'VISUALIZATION',
  SPELL: 'SPELL',
  INTERPRETER: 'INTERPRETER',
  APPLICATION: 'APPLICATION',
};
